<template>
  <FullCalendar :options="calendarOptions" />
</template>
<script>
import FullCalendar from '@fullcalendar/vue'
import dayGridPlugin from '@fullcalendar/daygrid'
import timeGridPlugin from '@fullcalendar/timegrid'
import interactionPlugin from '@fullcalendar/interaction'
import listPlugin from '@fullcalendar/list'
import esLocale from '@fullcalendar/core/locales/es';

export default {
    name: 'Calendar',
    components: {
        FullCalendar // make the <FullCalendar> tag available
    },
    data() {
        return {            
            calendarOptions: {
                //slotDuration: '24:00',     
                //height: "100%",
                locale: esLocale,           
                events: [],
                plugins: [
                    dayGridPlugin,
                    timeGridPlugin,
                    listPlugin,
                    interactionPlugin // needed for dateClick
                ],
                eventClick: this.handleEventClick,
                headerToolbar: {
                    left: 'prev,next today',
                    center: 'title',
                    right: 'dayGridMonth,dayGridWeek,listWeek,listOneDay'
                },
                initialView: 'dayGridMonth',    
                views: {
                    listOneDay: {
                        type: 'listWeek',
                        duration: { days: 1 },
                        buttonText: 'Día'
                    }
                }
            }
        }
    },
    methods: {
        handleEventClick: function(event) {
            //Si cogemos directamente en evento que viene en el click, no vienen los datos custom de id de tarea y cliente
            //Usamos el id del evento que es estandar para buscar el evento original en la lista del calendario
            var calEvent = this.calendarOptions.events[event.event.id];            
            //console.log(calEvent);
            this.setEventDialog(calEvent.title,calEvent.description,calEvent);
            /*var start = event.event.start;
            start = new Date(start.valueOf() - start.getTimezoneOffset() * 60000); 
            //Ajuste para GMT+1 / 0 entre la app y Nav
            this.$store.commit('saveDocumentDate',start);
            if (event.event.title == 'Pulse para añadir un parte'){                
                //this.$store.state.dialogParte = true;
                this.$router.push('Parte');
            } else {
                var docNo = event.event.title;
                this.readDocument(docNo);
                //this.$store.state.dialogParteDetalle = true;
                this.$router.push('ParteDetalle');
            }*/
        },
        
    },
    watch:{
        events: function(val){
            /*var events = [];
            var today = new Date();                   
            var startDate = new Date(today.valueOf());
            startDate.setDate(startDate.getDate() - 3);
            for (var i = 0; i <= 15; i++){ 
                var eventDate = new Date(startDate); 
                eventDate.setDate(eventDate.getDate() + i);                    
                var backgroundColor = '';
                var textColor = '';
                var borderColor = '';
                if (i == 3){
                    backgroundColor = 'green';
                }
                var event = {
                    id: i, 
                    title: 'Pulse para añadir un parte', 
                    date: eventDate,                 
                    allDay: true, 
                    backgroundColor: backgroundColor, 
                    textColor: textColor,
                    borderColor: borderColor
                }
                events.push(event);            
            }
            this.calendarOptions.events = events;*/
            this.calendarOptions.events = [];
            if ((val != null) && (val != undefined) && (val.length > 0)){
                for (var i = 0; i < val.length; i++){
                    event = {
                        no: val[i].no,
                        customer: val[i].customer,
                        description: val[i].title,
                        id: this.calendarOptions.events.length, 
                        title: val[i].customerName,
                        date: val[i].date,                 
                        allDay: true, 
                        backgroundColor: val[i].backgroundColor,
                        textColor: val[i].textColor
                    }
                    this.calendarOptions.events.push(event);                    
                }
            }
        }
    },
    computed:{
        events:{
            get(){
                return this.$store.state.rutasEventos;
            } 
        }      
    },
    mounted(){
        /*var events = [];
        var today = new Date();
        var startDate = new Date(today.valueOf());
        startDate.setDate(startDate.getDate() - 3);
        for (var i = 0; i <= 15; i++){ 
            var eventDate = new Date(startDate); 
            eventDate.setDate(eventDate.getDate() + i);                    
            var backgroundColor = '';
            var textColor = '';
            var borderColor = '';
            if (i == 3){
                backgroundColor = 'green';
            }
            var event = {
                id: i, 
                title: 'Pulse para añadir un parte', 
                date: eventDate,                 
                allDay: true, 
                backgroundColor: backgroundColor, 
                textColor: textColor,
                borderColor: borderColor
            }
            events.push(event);            
        }*/
        this.getRutas();        
        //this.calendarOptions.events = events;
    }
}
</script>
<style >
    .fc-list-event-time{display: none}
    .fc-toolbar-title{
        font-size: 10pt;
    }
    .fc .fc-toolbar-title{
        font-size: 1em;
    }
    .fc-event-today{
        background-color: bisque;
    }
</style>